module.exports = __webpack_public_path__ + "static/media/shop_anchorage_2.2c5bd08a.svg";